export default __webpack_public_path__ + "static/media/carouselThree.ba91f99c.png";